import { render, staticRenderFns } from "./PhotographyCollaboratorsTwoSection.vue?vue&type=template&id=6870d228"
import script from "./PhotographyCollaboratorsTwoSection.vue?vue&type=script&lang=ts"
export * from "./PhotographyCollaboratorsTwoSection.vue?vue&type=script&lang=ts"
import style0 from "./PhotographyCollaboratorsTwoSection.vue?vue&type=style&index=0&id=6870d228&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports